import { Shadow, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

interface ProductTabletCardProps {
  children: React.ReactNode;
  index: number;
}

export const ProductTabletCard: React.FC<ProductTabletCardProps> = ({ children, index }) => {
  return (
    <Shadow testId="shadow" level={1} borderRadius="8px" key={index.toString()}>
      <VStack space={Spacing['inset.xs']}>{children}</VStack>
    </Shadow>
  );
};
